import { fa } from "./course-format";

type Props = {
  isBuying: boolean;
  isUnavailable?: boolean;
  isFreeCourse?: boolean;
  finalPrice: number;
  originalPrice: number | null;
  discountPercent: number;
  onProceed: () => void;
  /**
   * Drop the fixed positioning and render as a card in the flow. For the
   * desktop side rail, where a bar pinned to the bottom of the viewport would
   * float in the middle of the screen instead of over the content.
   */
  inline?: boolean;
};

export default function CourseStickyCTA({
  isBuying,
  isUnavailable,
  isFreeCourse,
  finalPrice,
  originalPrice,
  discountPercent,
  onProceed,
  inline = false,
}: Props) {

  const fullWidthLabel = isUnavailable
    ? "ثبت نام در این دوره مجاز نیست"
    : isBuying
      ? "در حال پردازش..."
      : isFreeCourse
        ? "شروع دوره رایگان"
        : null;

  return (
    <div
      className={
        inline
          ? "rounded-2xl bg-background p-3"
          : "fixed bottom-0 left-0 right-0 bg-background border-t border-content3 z-20 max-w-xl mx-auto p-3"
      }
    >
      {fullWidthLabel ? (
        <button
          onClick={onProceed}
          disabled={isBuying || isUnavailable}
          className="w-full text-white p-3 rounded-lg font-semibold text-sm bg-primary disabled:opacity-70"
        >
          {fullWidthLabel}
        </button>
      ) : (
        <div className="flex items-center gap-3">


          <button
            onClick={onProceed}
            disabled={isBuying}
            className="grow text-white px-5 py-2.5 rounded-lg font-semibold text-sm bg-primary disabled:opacity-70"
          >
            خرید دوره
          </button>

          <div className="flex-1 min-w-0 flex flex-col items-end">
            <div className="flex items-center gap-2">
              {discountPercent > 0 ? (
                <span className="shrink-0 inline-flex items-center justify-center rounded-md bg-red-500 text-white text-[11px] font-bold px-1.5 py-0.5">
                  {fa(discountPercent)}%
                </span>
              ) : null}
              {originalPrice ? (
                <span className="text-xs text-default-400 line-through truncate">
                  {fa(originalPrice)}
                </span>
              ) : null}
            </div>
            <div className="mt-0.5 flex items-baseline gap-1">
              <span className="text-base font-extrabold text-default-900 truncate">
                {fa(finalPrice)}
              </span>
              <span className="text-[11px] text-default-500">تومان</span>
            </div>
          </div>
        </div>
      )}
      <div className="safe-area-inset-bottom w-full"></div>
    </div>
  );
}
